import validate from "/opt/dist/node_modules/nuxt/dist/pages/runtime/validate.js";
import page_45seo_45data_45global from "/opt/dist/app/middleware/pageSeoData.global.js";
import router_45city_45change_45global from "/opt/dist/app/middleware/routerCityChange.global.js";
import manifest_45route_45rule from "/opt/dist/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  page_45seo_45data_45global,
  router_45city_45change_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}